<template>
  <v-container class="pa-0">
    <h3 class="mb-3">Create a Group</h3>
    <hr class="thick" >
    <v-layout
      row
      wrap>
      <v-flex sm12>
        <v-form
          ref="newGroupForm"
          v-model="form.valid">
          <v-text-field
            :rules="form.name"
            v-model="group.name"
            label="Group Name*"
            required
            class="mt-4 pb-2 mb-2"/>
          <v-textarea
            :rules="form.description"
            v-model="group.description"
            label="Description*"
            placeholder="Describe your group"
            outline/>
          <div class="adminOnly pa-3" v-if="this.$auth.check(['uber_admin','es_admin','coach'])">
            <p><strong>Administrator Only</strong></p>
            <v-select

              :rules="form.group_type_id"
              v-model="group.group_type_id"
              :items="group_types"
              :loading="this.group_types.length>0?false:&quot;primary&quot;"
              label="Group Type*"
              item-text="friendly_name"
              item-value="id"
              required />
            <v-switch
              :label="`Global? ${group.global ? 'Yes': 'No' }`"
              v-model="group.global"
              color="secondary"
              class="mt-2 mb-0 pb-0"/>

          </div>
          <v-switch
            :label="`Access: ${group.public ? 'Public': 'Private' }`"
            v-model="group.public"
            color="secondary"
            class="mt-2 mb-0 pb-0"/>
          <p style="mt-2">Add members below by typing their name and then selecting them.
          <br >Don't worry, we know who you are, no need to add yourself!</p>
          <v-autocomplete
            :items="ac_results"
            @change="search = ''"
            v-model="members"
            :loading="loading"
            :search-input.sync="search"
            label="Add Members"
            class="mb-0"
            item-text="display_name"
            item-value="id"
            item-avatar="profile_photo.avatar"
            multiple chips cache-items outline hide-selected no-data-text="Start typing to search">
            <template
              slot="selection"
              slot-scope="data">
              <v-chip
                :selected="data.selected"
                :key="JSON.stringify(data.item)"
                close
                class="chip--select-multi"
                @input="data.parent.selectItem(data.item)">
                <AmazeAvatar
                  :user="data.item"
                  :key="data.item.id"
                  size="25px"
                  hide-tip="true"/>
                {{ data.item.display_name }}
              </v-chip>
            </template>
            <template
              slot="item"
              slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"/>
              </template>
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.display_name"/>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
          <v-btn
            color="primary"
            class="ml-0"
            @click.enter="saveGroup">Save Changes</v-btn>
          <v-btn
            class="ml-1"
            @click="$router.go(-1)" flat outline>Cancel and Close</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style lang="scss" scoped>
.adminOnly{
    background-color: #f9f5f1;
}
</style>

<script>
import AmazeAvatar from '@/components/Widgets/AmazeAvatar'

export default {
  components: {
    AmazeAvatar
  },
  data () {
    return {
      loading: false,
      search: null,
      ac_results: [],
      group: { public: false, global: false },
      group_types: [],
      members: [],
      form: {
        valid: false,
        name: [v => !!v || 'A group name is required'],
        description: [
          v =>
            !!v ||
              'Always a challenge, but descriptions help distinguish your group'
        ],
        group_type_id: [v => !!v || 'Please select a group type']
      }
    }
  },
  watch: {
    search (val) {
      val && this.querySelections(val)
    }
  },
  mounted () {
    this.$http.get('group_types/list').then(
      response => {
        this.group_types = response.body.data
      },
      response => {
        console.log('Error getting group types.')
      }
    )
  },
  methods: {
    querySelections (v) {
      this.loading = true
      setTimeout(() => {
        this.$http.get('users/autocomplete?q=' + v).then(
          response => {
            let people = response.body

            // Filter out yourself from the list
            let filtered = people.filter(
              item => item.id !== this.$auth.user().id
            )
            this.ac_results = filtered
          },
          response => {
            console.log('Error getting users from autocomplete.')
          }
        )
        this.loading = false
      }, 300)
    },
    saveGroup () {
      if (this.$refs.newGroupForm.validate()) {
        if (!this.group.group_type_id) {
          this.group.group_type_id = 1
        }
        var formData = {
          name: this.group.name,
          description: this.group.description,
          group_type_id: this.group.group_type_id,
          public: this.group.public,
          users: this.members,
          global: this.group.global
        }
        this.$http.post('groups', formData).then(
          response => {
            this.$store.commit('updateMessage', {
              message: 'Group saved.',
              snackbar: true
            })
            this.$store.commit('updateGroups')
            this.$router.replace({ path: '/group/' + response.body.data.id })
          },
          response => {
            console.log('Error saving profile')
          }
        )
      } else {
        this.$store.commit('updateMessage', {
          message:
              'Nice try, but some required information is missing. Give it another go!',
          snackbar: true
        })
      }
    }
  }
}
</script>
